import React, { useEffect, useState } from "react";
import AppContext from "../Context/Context";

export default function XmlUpdater() {
  const [apiUrl, setApiUrl] = useState( "api/Sitemap/sitemap.xml");
  const [xmlContent, setXmlContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
useEffect(() => { fetchXml();}, []);

 
 

  const fetchXml = async () => {
    try {
      setLoading(true);
      setMessage("");

      // Fetch XML from API
      const response = await fetch(AppContext.APIURL +apiUrl);

      if (!response.ok) {
        throw new Error("Failed to fetch XML");
      }

      // Read XML as text
      const xmlText = await response.text();

      setXmlContent(xmlText);
      setMessage("XML loaded successfully");
    } catch (error:any) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const downloadXml = () => {
    const blob = new Blob([xmlContent], {
      type: "application/xml",
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "SiteMap.xml";
    a.click();

    URL.revokeObjectURL(url);
  };

 

  return (
    <div
      style={{
        padding: "30px",
        fontFamily: "Arial",
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >

      <div style={{ marginBottom: "20px" }}>
       


       
        <button
          onClick={downloadXml}
          disabled={!xmlContent}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
          }}
        >
          Download XML
        </button>
      </div>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            color: "green",
            fontWeight: "bold",
          }}
        >
          {message}
        </div>
      )}

      <textarea
        value={xmlContent}
        rows={25}
        style={{
          width: "100%",
          padding: "15px",
          fontFamily: "monospace",
          fontSize: "14px",
          border: "1px solid #ccc",
        }}
      />
    </div>
  );
}